import React, {Fragment, useContext} from "react";
import PositionItem from "./PositionItem";
import {WindowContext} from "../../Service/Context/WindowContext";
import PositionSum from "./PositionSum";
import ProfileInjectWrapper from "../Profile/ProfileInjectWrapper";
import { getDocumentTranslator } from "../Document/documentLanguage";
import { useLingui } from "@lingui/react";
import { shouldHideQuantityAndPriceColumns } from "./positionDisplay";

export default ({formSubmission, resourceId, positions, taxType, isSummable, values, handleChange, document, onPositionChange}) => {
    const {windowWidth} = useContext(WindowContext);
    const { i18n } = useLingui();
    const t = getDocumentTranslator(i18n, document.language);

    if (!positions) {
        return null;
    }

    if (positions.length === 0) {
        return null;
    }

    const hideQuantityAndPriceColumns = shouldHideQuantityAndPriceColumns(positions);

    let styles = {
        container: {
          marginTop: 20,
          marginBottom: 20,
        },
        firstColumn: {
            width: 50,
            display: "flex",
            justifyContent: "center",
        },
        textColumn: {
            flex: 1,
        },
        priceColumn: {
            width: windowWidth < 800 ? 110 : (windowWidth > 1100 ? 130 : 120),
            textAlign: "right"
        }
    };

    return (
        <div style={styles.container}>
            <div style={{display: "flex"}}>
                <div style={styles.firstColumn}/>
                <div style={styles.textColumn}>{t("description")}</div>
                {windowWidth > 800 && !hideQuantityAndPriceColumns && <div style={styles.priceColumn}>{t("amount")}</div>}
                {windowWidth > 800 && !hideQuantityAndPriceColumns && <div style={styles.priceColumn}>{t("price")}</div>}
                <div style={styles.priceColumn}>{t("total")}</div>
            </div>
            <hr/>
            {positions.map((position, index) => {
                return <Fragment key={position.id ?? index}>
                        <PositionItem _document={document} taxType={taxType} formSubmission={formSubmission} values={values} position={position} handleChange={handleChange} columnStyles={styles} onPositionChange={onPositionChange} hideQuantityAndPriceColumns={hideQuantityAndPriceColumns} />
                        <hr/>
                    </Fragment>
            })}
            <ProfileInjectWrapper resourceId={resourceId}>
                <PositionSum isSummable={isSummable} document={document} resourceId={resourceId} values={values} positions={positions} columnStyles={styles} />
            </ProfileInjectWrapper>
        </div>

    )
}
